import { service } from '@ember/service';
import Component from '@glimmer/component';
import type IpadIconService from 'garaje/services/ipad-icon';

interface IpadIconSignature {
  Args: {
    deviceType: string;
    isSleeping: boolean;
    isStatusBad: boolean;
    safeStyle?: string;
  };
}

export default class IpadIcon extends Component<IpadIconSignature> {
  @service declare ipadIcon: IpadIconService;

  get ipadIconURI(): string {
    return this.ipadIcon.getIconURI(this.args.deviceType, this.args.isSleeping, this.args.isStatusBad);
  }

  <template><img src={{this.ipadIconURI}} style={{if @isStatusBad @safeStyle ""}} alt="iPad icon" /></template>
}
